// Counter Print Agent router.
// If a local print agent is configured for this terminal (localStorage), print jobs are
// POSTed to it so they land on the correct physical printer with NO dialog:
//   target "receipt" -> the till/receipt printer,  target "a4" -> the A4 printer.
// If no agent is configured (e.g. office PCs), we fall back to the normal browser print dialog.
const AGENT_KEY = "anx_print_agent_url"; // e.g. http://127.0.0.1:9711

export function getPrintAgent() {
  return localStorage.getItem(AGENT_KEY) || "";
}
export function setPrintAgent(url) {
  if (url && url.trim()) localStorage.setItem(AGENT_KEY, url.trim());
  else localStorage.removeItem(AGENT_KEY);
}

// Render full HTML either through the local agent (silent, correct printer) or the browser.
// target: "receipt" | "a4"
// opts.duplex: ask the agent to print back-to-back (long edge)
export async function routePrint(target, html, title = "Print", opts = {}) {
  if (window.__captureDoc) { window.__captureDoc.push(html); return true; } // emailing: keep the HTML for the PDF
  const agent = getPrintAgent();
  if (agent) {
    try {
      const res = await fetch(agent.replace(/\/+$/, "") + "/print", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ target, title, html, duplex: !!opts.duplex }),
      });
      if (res.ok) return true; // agent handled it silently
    } catch (e) {
      /* agent unreachable — fall back to the browser dialog below */
    }
  }
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return false; }
  w.document.write(html);
  w.document.close();
  w.focus();
  w.print();
  return false;
}
